import React from 'react'
import { Popover, Grid, Divider } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Box from 'components/Box'
import Button from 'components/Button'
import SkillExperienceSlider from './SkillExperienceSlider'

interface Skill {
  id: string
  name: string
  experience: number
}

export interface ISkillsInputPopoverProps {
  popoverAnchor: HTMLElement
  skill: Skill
  onClose: () => void
  onChange: (skill: Skill) => void
}

function SkillsInputPopover(props: ISkillsInputPopoverProps) {
  const { popoverAnchor, skill, onChange, onClose } = props
  const theme = useTheme()
  const popoverOpen = Boolean(popoverAnchor)

  const handleExperienceChange = (value: number) => {
    onChange({
      ...skill,
      experience: value,
    })
  }

  const handleKeyDown = (e: React.KeyboardEvent<any>) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      e.preventDefault()
      onClose()
    }
  }

  const blockEnterKeyEvent = (e: React.KeyboardEvent<any>) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      e.preventDefault()
    }
  }

  if (!skill) return null

  return (
    <Popover
      open={popoverOpen}
      anchorEl={popoverAnchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onKeyDown={handleKeyDown}
      onKeyUp={blockEnterKeyEvent}
      onKeyPress={blockEnterKeyEvent}
    >
      <div style={{ width: 360, maxWidth: '100%' }} data-cy="skills-input-popover">
        <Box variant="compact">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SkillExperienceSlider
                data-cy={`experience-slider-${skill.name}`}
                style={{ marginBottom: theme.spacing(-1) }}
                skill={skill}
                onChange={handleExperienceChange}
              />
            </Grid>
          </Grid>
        </Box>

        <Divider style={{ margin: 0, marginBottom: theme.spacing(1) }} />

        <Box variant="compact">
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ textAlign: 'right' }}>
              <Button color="secondary" onClick={onClose} data-cy="skills-input-popover-done">
                Done
              </Button>
            </Grid>
          </Grid>
        </Box>
      </div>
    </Popover>
  )
}

export default React.memo(SkillsInputPopover)
